export default function urlParamsObject(urlString) {
	const urlInstance = new URL(urlString);
	const searchParams = urlInstance.searchParams;

	return Object.fromEntries(
		Array.from(searchParams.entries())
	);
}